import { Link } from 'gatsby';
import React from 'react';
import ArrowButton from '../../ui/ArrowButton';

const AboutHoverWorkWithUs: React.FC = () => (
  <ArrowButton
    colorScheme="primary"
    variant="minimal"
    mb={{ base: 400, tablet: 0 }}
    as={Link}
    to={`${process.env.GATSBY_V2_PREFIX}/careers`}
    sx={{
      // TODO(buttons): remove when we remove padding in Blueprint
      div: { pl: 0, pr: 50 },
    }}
  >
    Work with us
  </ArrowButton>
);

export default AboutHoverWorkWithUs;
